import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, throwError, EMPTY, of } from 'rxjs';
import { retry, catchError, shareReplay } from 'rxjs/operators';
import { login } from '../model/login';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { MenuItem, MenuData } from '../model/menu.model';
import { AppSetting } from '../model/setting/SystemControl';
import { response } from '../model/Response';
import { LocalStorageService } from './LocalStorageService';
import { CompanyInfo } from '../model/setting/Company';
import { Branchinfo } from '../model/master/branch';
import { select, Store } from '@ngrx/store';
import { AppState } from '../store/buid.reducer';
import { BusinessclasstInfo } from '../model/master/businessclass';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  //rahul
  myAppApi: string;
  myAppUrlLogin: string;
  private userSubject: BehaviorSubject<login>;
  public loginSubject: Observable<login>;
  public parentMenu: MenuData;

  BUID: string;
  private cache = new Map<string, Observable<any>>();
  constructor(private _http: HttpClient, private router: Router, private storageService: LocalStorageService, private store: Store<AppState>) {
    this.myAppApi = environment.appUrl;
    this.myAppUrlLogin = 'api/Authentication';
    this.userSubject = new BehaviorSubject<login>(JSON.parse(localStorage.getItem('login')));
    this.loginSubject = this.userSubject.asObservable();
    this.store.pipe(select(state => state.buidState.BUID)).subscribe(buid => {
      this.BUID = buid
    });

  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json; charset=utf-8',
      'Accept': '*/*'
    })
  }

  //login
  //login
   ctr=0;
  loginFun(login): Observable<login | any> {
    console.log("Service in login fired "+( ++this.ctr));
    return this._http.post<login>(this.myAppApi + this.myAppUrlLogin, login, this.httpOptions)
      .pipe(shareReplay(1),
        map((loginData) => {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem('login', JSON.stringify(loginData));

          // Optionally, you could fetch app settings here and save it to storage
          // this.getAppSetting("0").subscribe((data) => {
          //   this.storageService.saveData('AS', JSON.stringify(data));
          // });
   console.log("Login Result "+( ++this.ctr));
         this.userSubject.next(loginData);
          return loginData;
        }),
        catchError((error) => {
          // Handle error, maybe log it or display a message

          return of(error); // Return the error as observable
        })
      );
  }
  //App Setting
  apiResponse: any;
  getAppSetting(source: string): Observable<AppSetting> {
    return this._http.get<response>(this.myAppApi + "api/Master/BusinessSettingList?Id=0", this.httpOptions)
      .pipe(map(response => {
        this.apiResponse = response;
        return this.apiResponse.data[0];
      }));
  }


  public get userValue(): login {

    return this.userSubject.value;
  }
  //companydatabase
  logout() {
    // remove user from local storage and set current user to null
    localStorage.removeItem('login');
    // localStorage.removeItem('CompanySelectData');
    this.userSubject.next(null);

    this.router.navigate(['/account/login']);
  }



    // getParentMenu() {
    //   const promise = new Promise<MenuData>((resolve, reject) => {
    //     let apiURL = this.myAppApi + "api/SystemMaster/BindMenu?Event=2&ParentId=0";
    //     this._http.get<MenuData>(apiURL).subscribe({
    //       next: (res: any) => {
    //         var data = (res as MenuData)
    //         for (let i = 0; i < data.data.length; i++) {
    //           data.data[i].link = "/home/module/" + data.data[i].id;
    //         }
    //         resolve(data);
    //       },
    //       error: (err: any) => {
    //         reject(err);
    //       },
    //       complete: () => {
    //       },
    //     }
    //     );
    //   });
    //   return promise;
    // }


  
  // getParentMenu(): Observable<MenuData> {
  //   let url = this.myAppApi + "api/SystemMaster/BindMenu?Event=2&ParentId=0";

  //    if (!this.cache.has(url)) {
  //     const request$ = this._http.get(url).pipe(
  //       shareReplay(1)
  //     );
  //     this.cache.set(url, request$);
  //   }
  //   return this.cache.get(url)!;
  // }


   private parentMenu$!: Observable<MenuData>;
  getParentMenu(): Observable<MenuData> {
   
   if (!this.parentMenu$) {
    console.log('API called to fetch parent menu Start');
   
      const apiURL = this.myAppApi +
        'api/SystemMaster/BindMenu?Event=2&ParentId=0';
 console.log('API:', apiURL);
      this.parentMenu$ = this._http.get<MenuData>(apiURL).pipe(
        map(res => {
          res.data.forEach(item => {
            item.link = '/home/module/' + item.id;
          });
          return res;
        }),
        shareReplay(1)
      );
      console.log('API called to fetch parent menu END');
    }

    return this.parentMenu$;
  }

  getParentMenuNew(): Observable<MenuData> {
    let url = this.myAppApi + "api/SystemMaster/BindMenu?Event=2&ParentId=0";

     if (!this.cache.has(url)) {
       console.log('API called to fetch getParentMenuNew Start');
      const request$ = this._http.get(url).pipe(
        shareReplay(100)
      );
      this.cache.set(url, request$);
       console.log('API called to fetch getParentMenuNew END');
    }
    return this.cache.get(url)!;
  }




  
  getChildMenu(menuId: number): Observable<MenuData> {
    // let url = this.myAppApi + "api/SystemMaster/BindMenu?Event=3&ParentId=" + menuId + "&UserId=0&UserRoleId=0";
    let url = this.myAppApi + `api/SystemMaster/BindMenu?Event=3&ParentId=${menuId}`;
    const key = url.trim().toLowerCase();

    if (!this.cache.has(key)) {
      console.log('CACHE MISS → API CALL', key);

      const request$ = this._http.get(key).pipe(
        shareReplay({ bufferSize: 1, refCount: true })
      );

      this.cache.set(key, request$);
    } else {
      console.log('CACHE HIT', key);
    }

    return this.cache.get(key)!;

//       if (!this.cache.has(url)) {
//           console.log('Child '+url);
//       const request$ = this._http.get(url).pipe(
//         shareReplay(1)
//       );
//       this.cache.set(url, request$);
//         console.log('API called to fetch getChildMenu END');
//     }
//     return this.cache.get(url)!;
    
    // return this._http.get<MenuData>(url, this.httpOptions)
    //   .pipe(map(response => {
    //     return response;
    //   }))
  };

  getCompanyList(): Observable<CompanyInfo[]> {

    let url = this.myAppApi + "api/SystemMaster/CompanyList?Id=0&UserId=0&LicId=0&db=0"

    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data;
      }))
  };

  CompanyHeaderList(): Observable<CompanyInfo> {

    let url = this.myAppApi + "api/Master/CompanyHeaderList"
    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data[0];
      }))
  };

  getForRightsCompanyList(uid,licId): Observable<CompanyInfo[]> {

    let url = this.myAppApi + `api/SystemMaster/UserCompanyRightsList?Id=0&UserId=${uid}&LicId=${licId}&db=0`

    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data;
      }))
  };
  getForRightsBranchList(uid): Observable<Branchinfo[]> {

    let url = this.myAppApi + "api/SystemMaster/UserBranchRightsList?BranchId=0&UserId="+uid;

    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data;
      }))
  };
  getCompanyListById(id: number): Observable<CompanyInfo[]> {

    let url = this.myAppApi + `api/SystemMaster/CompanyList?Id=${id}&UserId=0&LicId=0&db=0`;
    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data;
      }))
  };

    getBusinessClassListRights(userId: string): Observable<BusinessclasstInfo[]> {

    let url = this.myAppApi + `api/SystemMaster/UserBusinessStationRightsList?BusinessStationId=0&UserId=${userId}`;
    return this._http.get<response>(url, this.httpOptions)
      .pipe(map(response => {
        return response.data;
      }))
  };


  logoutOfOtherDevices(userId, organizationId) {
    let apiURL = this.myAppApi + `api/Authentication/logout?userId=${userId}&organizationId=${organizationId}`;

    return this._http.post<MenuData>(apiURL, this.httpOptions)
      .pipe(map(response => {


        return response;
      }))

  }


  //.............................................end of company area......................................//
  errorHandler(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
